import { Component, OnInit, inject } from '@angular/core';
import { Validators, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { OrderClaimRequest } from 'src/app/common/OrderClaimRequest';
import { AppProfileService } from 'src/app/services/profile.service';
import { OrderService } from 'src/app/services/order.service';
import { KENDO_DATE } from '@progress/kendo-angular-intl';
import { FormRowComponent } from '../form-row/form-row.component';
import { take } from 'rxjs';

/** The cancellation request form; its type is inferred from here (#199). */
function buildOrderClaimRequestForm(fb: FormBuilder, orderClaimRequest: OrderClaimRequest) {
  return fb.group({
    orderDate: [orderClaimRequest?.orderDate, [Validators.required]],
    orderNumber: [orderClaimRequest?.orderNumber, [Validators.required]],
    serial: [orderClaimRequest?.serial, [Validators.required]],
  });
}
type OrderClaimRequestForm = ReturnType<typeof buildOrderClaimRequestForm>;

@Component({
    imports: [CommonModule, ReactiveFormsModule, KENDO_DATE, FormRowComponent],
    selector: 'app-order-claim-edit',
    templateUrl: './order-claim-request.component.html',
    styles: []
})
export class OrderClaimRequestComponent implements OnInit {
  fb = inject(FormBuilder);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private orderService = inject(OrderService);
  private profileService = inject(AppProfileService);

  orderId: string;
  posId: string;

  constructor() {
    this.orderClaimRequest = new OrderClaimRequest();
    this.orderClaimRequestForm = this.createForm(this.orderClaimRequest);
  }

  public orderClaimRequest: OrderClaimRequest;
  public orderClaimRequestForm: OrderClaimRequestForm;
  public submitted = false;
  public id: string;

  ngOnInit() {
    this.orderId = this.activatedRoute.snapshot.queryParamMap.get('orderId');
    this.posId = this.activatedRoute.snapshot.queryParamMap.get('posId');

    // Kept on purpose (#199): nothing reads the results of these two requests - they used to be
    // stored in private fields that no code used. The calls still fire; whether they are needed
    // at all is an open question. The profile is taken once so the subscription does not outlive
    // the page.
    this.profileService.currentProfile$.pipe(take(1)).subscribe();
    this.orderService.getById(this.orderId).subscribe();
  }

  createForm(orderClaimRequest: OrderClaimRequest): OrderClaimRequestForm {
    return buildOrderClaimRequestForm(this.fb, orderClaimRequest);
  }

  onBackClicked() {
    this.location.back();
  }

  get f() {
    return this.orderClaimRequestForm.controls;
  }
}
